import { render, staticRenderFns } from "./FaqsItemsView.vue?vue&type=template&id=5c953456"
import script from "./FaqsItemsView.vue?vue&type=script&lang=js"
export * from "./FaqsItemsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports